 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import HALF_TITLE from '@/components/half_title'
 import TITLE_PAGE from '@/components/title_page'
 import COPYRIGHT_PAGE from '@/components/copyright_page'
 import CONTENTS from '@/components/contents'
 import LIST from '@/components/list'
 import PREF from '@/components/pref'
 import NOTES from '@/components/notes'
 import CHAPTER_OPENING from '@/components/chapter_opening'
 import INTRO from '@/components/intro'
 import INTRO01 from '@/components/intro-01'
 import PT1 from '@/components/pt1'
 import PT1CH1 from '@/components/pt1-ch1'
 import PT1CH2 from '@/components/pt1-ch2'
 import PT1CH3 from '@/components/pt1-ch3'
 import PT2 from '@/components/pt2'
 import PT2CH1 from '@/components/pt2-ch1'
 import PT2CH2 from '@/components/pt2-ch2'
 import PT2CH3 from '@/components/pt2-ch3'
 import PT3 from '@/components/pt3'
 import BIOGRAPHIES from '@/components/biographies'
 import FILMOGRAPHY from '@/components/filmography'
 import LOVE_2 from '@/components/love_2'
 import BIBLIOGRAPHY from '@/components/bibliography'
 import CHRONOLOGICAL from '@/components/chronological'
 import INDEX from '@/components/index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/half_title",
 			"name" : "half_title",
 			"component" : HALF_TITLE
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/copyright_page",
 			"name" : "copyright_page",
 			"component" : COPYRIGHT_PAGE
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/list",
 			"name" : "list",
 			"component" : LIST
 		},
 		{
 			"path" : "/pref",
 			"name" : "pref",
 			"component" : PREF
 		},
 		{
 			"path" : "/notes",
 			"name" : "notes",
 			"component" : NOTES
 		},
 		{
 			"path" : "/chapter_opening",
 			"name" : "chapter_opening",
 			"component" : CHAPTER_OPENING
 		},
 		{
 			"path" : "/intro",
 			"name" : "intro",
 			"component" : INTRO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js